import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { pagesState, mySession, GetOrderAsync, pageDetails, CancelOrderItemAsync, orderDetailsList, saveSelectedInvoices, invoiceDetails, RegisterPaymentAsync, checkSessionAsync, initiateAction, paymentloading } from './controller';
import useDynamicRefs from 'use-dynamic-refs';
import moment from 'moment';
import { Tabs, Tab, Modal } from 'react-bootstrap';
import CurrencyFormat from 'react-currency-format';

export function Invoices() {
    const [totalValueCalculate, setTotalValueCalculate] = useState(0);
    const dispatch = useDispatch();
    const page_urlParams = useParams();

    const pages_state = useSelector(pagesState);
    const invoice_Details = useSelector(invoiceDetails);
    const OrderDetails = useSelector(pageDetails);
    const orderDetails_List = useSelector(orderDetailsList);
    const payment_loading = useSelector(paymentloading);

    const my_Session = useSelector(mySession);
    const [getRef, setRef] = useDynamicRefs();

    var [showInvoice, setshowInvoice] = useState(null);
    var toggleshowInvoice = (index) => {
        if (showInvoice === index) {
            setshowInvoice(null);
        } else {
            setshowInvoice(index);
        }
    };

    var [showCancelItemModal, setshowCancelItemModal] = useState(null);
    var handleshowCancelItemModal = (index) => {
        if (showCancelItemModal === index) {
            setshowCancelItemModal(null);
        } else {
            setshowCancelItemModal(index);
        }
    };

    const cancelItem = (item_id) => {
        var itemList = [];
        itemList.push(item_id);
        var data = {
            requestId: page_urlParams.orderId,
        }
        var cancel_data = [data, {
            OrderItemIds: itemList,
            StatusId: "2ddec370-8acc-4be4-9349-b6462c4978b0",
            LastModifiedUserId: ''
        }]

        dispatch(CancelOrderItemAsync(cancel_data));
        setshowCancelItemModal(null);
    }


    const selectInvoice = (e, index, data) => {
        var getInvItemsId = Object.assign([], invoice_Details.getInvItemsId);
        var displayInvoiceItem = Object.assign([], invoice_Details.displayInvoiceItem);
        var disabledIfNoSelectInvoice = invoice_Details.disabledIfNoSelectInvoice;
        var totalAmount = parseInt(invoice_Details.totalAmount ? invoice_Details.totalAmount : 0);

        var getQuote = [];
        if (e.target.checked) {
            getInvItemsId.push(data.invoiceId);
            displayInvoiceItem.push(data);
            totalAmount += data.totalAmount;
            setTotalValueCalculate(totalValueCalculate + data.totalAmount);
        } 
        else {
            getQuote.push(data.invoiceId);

            var i = getInvItemsId.length;
            var p = displayInvoiceItem.length;

            while (i--) {
                if (getQuote.indexOf(getInvItemsId[i]) !== -1) {
                    getInvItemsId.splice(i, 1);
                }
            }
            while (p--) {
                if (getQuote.indexOf(displayInvoiceItem[p].invoiceId) !== -1) {
                    displayInvoiceItem.splice(p, 1);
                }
            }

            totalAmount -= data.totalAmount;
            setTotalValueCalculate(totalValueCalculate - data.totalAmount);
        }

        if (getInvItemsId.length > 0) {
            disabledIfNoSelectInvoice = false;
        } else {
            disabledIfNoSelectInvoice = true;
        }
        var result = {
            getInvItemsId: getInvItemsId,
            displayInvoiceItem: displayInvoiceItem,
            totalAmount: totalAmount,
            disabledIfNoSelectInvoice: disabledIfNoSelectInvoice,
        }
        dispatch(saveSelectedInvoices(result));
        // //console.log(getInvItemsId, displayInvoiceItem, totalAmount);
    }

    const proceed2pay = () => {
        var data = {
            OrderCode: pages_state.orderCodes2,
            InvoiceIds: invoice_Details.getInvItemsId
        }
        dispatch(RegisterPaymentAsync(data));
    }

    useEffect(() => {
        dispatch(initiateAction());
        dispatch(checkSessionAsync());
        var data = {
            requestId: page_urlParams.orderId,
        }
        dispatch(GetOrderAsync(data));
    }, []);


    return (
        <section id="requests">
            <div className="container-fluid mt-3 minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h2 className="pageTitle mt-2">Request Order: {OrderDetails && OrderDetails.OrderCode}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-start align-items-center flex-wrap">
                                <div className="font-weight-bold text-18 theme-color">
                                    <span className="material-icons-outlined align-middle pb-1">near_me</span> Navigation: &nbsp;
                                </div>
                                <Link to={'/requests'} className="btn btn-outline-primary me-2 mb-2"><span className="material-icons-outlined align-middle pb-1">reply</span> My Request List</Link>
                                <div className="position-relative">
                                    <Link to={`/my-requests/${page_urlParams.orderId}`} className="btn btn-outline-primary me-2 mb-2"><span className="material-icons-outlined align-middle pb-1">reply</span> Order Details</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-8">
                            <div className="row m-0">
                                <div className="col-md-12 p-0">
                                    {(pages_state.status !== 'idle' || pages_state.status === 'rejected') &&
                                        <div className="card overflow-hidden mb-3">
                                            <div className="card-header text-light d-flex justify-content-between align-items-center flex-row flex-wrap"></div>
                                            <div className="card-body">
                                                <div className="loadingScreen text-center bg-white"><img src="./images/loading.gif" className="icons-loading" alt="" /> Getting Payment Info</div>
                                            </div>
                                        </div>
                                    }
                                    {orderDetails_List && orderDetails_List.map((data, index) => {
                                        return (
                                            <div className="card overflow-hidden mb-3" key={index}>
                                                <div className="card-header text-light d-flex justify-content-start align-items-center flex-row flex-wrap"></div>
                                                <div className="card-body d-flex justify-content-between flex-row flex-wrap">
                                                    <div>
                                                        <div>
                                                            {data.StatusCode !== 'PP' && <label className="mb-2 theme-color text-18"><b>Invoice No - {data.invoiceCode}</b></label>}
                                                            {data.StatusCode === 'PP' && !data.invoiceIsExpired &&
                                                                <label htmlFor={'invoice-' + index} className="btn btn-primary mb-2">
                                                                    <input type="checkbox" id={'invoice-' + index} name="invoice" className="me-2" onChange={(e) => selectInvoice(e, index, orderDetails_List[index])} />
                                                                    <b>Invoice No - {data.invoiceCode}</b>
                                                                </label>}
                                                        </div>
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            {data.invoiceIsExpired && !data.IsPaid && <p className="me-2">
                                                                <span className="badge badge-danger">
                                                                    Expired
                                                                </span>
                                                            </p>}
                                                            {data.IsPaid && <p className="me-2">
                                                                <span className="badge badge-success">
                                                                    Paid
                                                                </span>
                                                            </p>}
                                                            {(data.orderItems[0].StatusCode === 'CLUC' || data.orderItems[0].StatusCode === 'CLRJ') && <p className="me-2">
                                                                <span className="badge badge-secondary">
                                                                    Cancelled
                                                                </span>
                                                            </p>}
                                                        </div>
                                                        <div>
                                                            <p className="mb-1">
                                                                <span className="text-dark">Invoice Due : </span>
                                                                <span className="theme-color">{moment(data.invDueDate).format('DD-MM-YYYY')}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    {(data.orderItems[0].StatusCode === 'CLUC' || data.orderItems[0].StatusCode === 'CLRJ' || !data.IsPaid) && <div>
                                                        <button className="btn btn-danger" onClick={() => handleshowCancelItemModal(index)}>Cancel</button>
                                                        <Modal show={showCancelItemModal === index} centered backdrop="static" size="lg">
                                                            <Modal.Header>
                                                                <Modal.Title>Cencel Request Confirmation</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body>
                                                                <div>
                                                                    <p>Are you sure you want to cancel this invoice? The following items will be removed.</p>
                                                                    <table className="table table-striped table-showItems">
                                                                        <thead style={{ backgroundColor: '#F4F4F4' }}>
                                                                            <tr>
                                                                                <th width="10%">No.</th>
                                                                                <th width="60%">Title</th>
                                                                                <th width="20%">Format</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {data.orderItems.map((item, index) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td>{index + 1}</td>
                                                                                        <td>{item.SourceTitle}</td>
                                                                                        <td>{item.Format}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}

                                                                        </tbody>

                                                                    </table>
                                                                </div>
                                                            </Modal.Body>
                                                            <Modal.Footer>
                                                                <button className="btn btn-danger" onClick={() => cancelItem(data.invoiceCode)}>Confirm</button>
                                                                <button className="btn btn-secondary" onClick={() => handleshowCancelItemModal(index)}>Cancel</button>
                                                            </Modal.Footer>
                                                        </Modal>
                                                    </div>}
                                                    <div className="flex-grow-1 mt-3" style={{ flexBasis: '100%' }} id={'quotation-' + { index }}>
                                                        <div className="lgt-box-header">
                                                            <h6 className="lgt-box-name font-weight-bold">INVOICE DETAILS:</h6>
                                                        </div>
                                                        <hr />
                                                        <div className="lgt-box-main overflow-auto">
                                                            <table className="table table-invoice">
                                                                <tbody>
                                                                    {data.bundlePrices.map((price, price_index) => {
                                                                        return (
                                                                            <tr key={price_index}>
                                                                                <th className="lgt-td-key">
                                                                                    {price.description}:
                                                                                    <div>
                                                                                        {price.orderItemName && price.orderItemName.map((name, name_index) => {
                                                                                            return (
                                                                                                <div key={name_index} className="text-left small text-muted clearfix" >
                                                                                                    {name}
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                    </div>
                                                                                </th>
                                                                                <td className="lgt-td-value align-top">
                                                                                    <span><CurrencyFormat value={parseFloat(price.amount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                    {data.itemPrices.map((price, price_index) => {
                                                                        return (
                                                                            <tr key={price_index}>
                                                                                <th className="lgt-td-key">
                                                                                    {price.description}:
                                                                                    <div>
                                                                                        {price.orderItemName && price.orderItemName.map((name, name_index) => {
                                                                                            return (
                                                                                                <div key={name_index} className="text-left small text-muted clearfix" >
                                                                                                    {name}
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                    </div>
                                                                                </th>
                                                                                <td className="lgt-td-value align-top">
                                                                                    <span><CurrencyFormat value={parseFloat(price.amount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                                </td>
                                                                            </tr>

                                                                        )
                                                                    })}
                                                                    {data.groupPrices.map((price, price_index) => {
                                                                        return (
                                                                            <tr key={price_index}>
                                                                                <th className="lgt-td-key">
                                                                                    {price.description}:
                                                                                    <div>
                                                                                        {price.orderItemAANo && price.orderItemAANo.map((accessionNo, accessionNo_index) => {
                                                                                            return (
                                                                                                <div key={accessionNo_index} className="text-left small text-muted clearfix">
                                                                                                    {accessionNo}
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                    </div>
                                                                                </th>
                                                                                <td className="lgt-td-value align-top">
                                                                                    <span><CurrencyFormat value={parseFloat(price.amount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                                </td>
                                                                            </tr>

                                                                        )
                                                                    })}
                                                                    <tr>
                                                                        <th className="lgt-td-key">GST {parseInt(process.env.REACT_APP_GST)}%:</th>
                                                                        <td className="lgt-td-value align-top">
                                                                            <span><CurrencyFormat value={parseFloat(data.gst).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="lgt-td-key total">Total w/GST (SGD):</th>
                                                                        <td className="lgt-td-value align-top font-weight-bold">
                                                                            <span><CurrencyFormat value={parseFloat(data.totalAmount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card overflow-hidden mb-3">
                                <div className="card-header text-light d-flex justify-content-between align-items-center flex-row flex-wrap"></div>
                                <div className="card-body">
                                    <div className="card-content d-flex justify-content-between w-100 flex-wrap">
                                        <div className="lgt-box-header w-100">
                                            {invoice_Details && invoice_Details.disabledIfNoSelectInvoice && <p className="theme-color">Press <b>[Invoice No - INV]</b> button to select invoice and pay.</p>}

                                            <div>
                                                {invoice_Details && invoice_Details.displayInvoiceItem.map((data, index) => {
                                                    return (
                                                        <div key={index} className="flex-grow-1 mt-3" style={{ flexBasis: '100%' }} id={'quotation-' + { index }}>
                                                            <div className="lgt-box-header">
                                                                <h6 className="lgt-box-name theme-color font-weight-bold cursor_pointer" onClick={() => toggleshowInvoice(index)}>Invoice - {data.invoiceCode} <span className="material-icons-outlined align-middle">{showInvoice === index ? 'expand_less' : 'expand_more'}</span></h6>
                                                            </div>
                                                            <div className="lgt-box-main overflow-auto">
                                                                <table className="table">
                                                                    <tbody>
                                                                        {data.bundlePrices.length > 0 && showInvoice === index && data.bundlePrices.map((price, price_index) => {
                                                                            return (
                                                                                <tr key={price_index}>
                                                                                    <th className="lgt-td-key">
                                                                                        {price.description}:
                                                                                        <div>
                                                                                            <div className="text-left small text-muted clearfix" >
                                                                                                No. of item(s): {price.orderItemName.length}
                                                                                            </div>
                                                                                        </div>
                                                                                    </th>
                                                                                    <td className="lgt-td-value align-top">
                                                                                        <span><CurrencyFormat value={parseFloat(price.amount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                        {data.itemPrices.length > 0 && showInvoice === index && data.itemPrices.map((price, price_index) => {
                                                                            return (
                                                                                <tr key={price_index}>
                                                                                    <th className="lgt-td-key">
                                                                                        {price.description}:
                                                                                        <div>
                                                                                            <div className="text-left small text-muted clearfix" >
                                                                                                No. of item(s): {price.orderItemName.length}
                                                                                            </div>
                                                                                        </div>
                                                                                    </th>
                                                                                    <td className="lgt-td-value align-top">
                                                                                        <span><CurrencyFormat value={parseFloat(price.amount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                                    </td>
                                                                                </tr>

                                                                            )
                                                                        })}
                                                                        {data.groupPrices.length > 0 && showInvoice === index && data.groupPrices.map((price, price_index) => {
                                                                            return (
                                                                                <tr key={price_index}>
                                                                                    <th className="lgt-td-key">
                                                                                        {price.description}:
                                                                                        <div>
                                                                                            {price.orderItemAANo && price.orderItemAANo.map((accessionNo, accessionNo_index) => {
                                                                                                return (
                                                                                                    <div key={accessionNo_index} className="text-left small text-muted clearfix">
                                                                                                        {accessionNo}
                                                                                                    </div>
                                                                                                )
                                                                                            })}
                                                                                        </div>
                                                                                    </th>
                                                                                    <td className="lgt-td-value align-top">
                                                                                        <span><CurrencyFormat value={parseFloat(price.amount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                                    </td>
                                                                                </tr>

                                                                            )
                                                                        })}
                                                                        {showInvoice === index && <tr>
                                                                            <th className="lgt-td-key">GST {parseInt(process.env.REACT_APP_GST)}%:</th>
                                                                            <td className="lgt-td-value align-top">
                                                                                <span><CurrencyFormat value={parseFloat(data.gst).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                            </td>
                                                                        </tr>}
                                                                        <tr>
                                                                            <th className="lgt-td-key total">Total w/GST (SGD):</th>
                                                                            <td className="lgt-td-value align-top">
                                                                                <span><CurrencyFormat value={parseFloat(data.totalAmount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>

                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            {invoice_Details && invoice_Details.totalAmount > 0 && <div className="mt-3 mb-2">
                                                <span className="font-weight-bold theme-color">Total Payable (SGD): <CurrencyFormat value={invoice_Details ? parseFloat(totalValueCalculate).toFixed(2) : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                            </div>}
                                            {!payment_loading && <button onClick={proceed2pay} disabled={invoice_Details && invoice_Details.disabledIfNoSelectInvoice} className="btn btn-primary w-100">Proceed to Pay</button>}
                                            {payment_loading && <button disabled className="btn btn-primary w-100"><img src="./images/loading.gif" className="icons-loading" alt="" /></button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    );
}





